module.exports = __webpack_public_path__ + "static/img/friend12.b8a9fb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend12.jpg
// module id = op8I
// module chunks = 1